import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import DefaultTooltipContent from 'recharts/lib/component/DefaultTooltipContent';

const renderTooltip = (props) => {
  if (props.active) {
    const { payload, ...otherProps } = props;
    
    console.log(payload);

    let newPayload = payload;
    newPayload.push({
      name: "Total", 
      value: (
        parseInt(payload[0].payload.used) +
        parseInt(payload[0].payload.not_used) +
        parseInt(payload[0].payload.canceled)
      )
    });

    return (
      <DefaultTooltipContent {...otherProps} payload={newPayload} />
    );
  }

  return null;
}

export default ({ data }) => {
  return (
    <div className="chart-container">
      <ResponsiveContainer>
        <BarChart data={data}>
          <XAxis dataKey="date_month"/>
          <YAxis/>
          <CartesianGrid strokeDasharray="3 3"/>
          <Tooltip content={renderTooltip}/>
          <Legend />
          <Bar name="Canceladas" dataKey="canceled" stackId="a" fill="#9cc177" />
          <Bar name="Não utilizadas" dataKey="not_used" stackId="a" fill="#F4D03F" />
          <Bar name="Utilizadas" dataKey="used" stackId="a" fill="#509ee3" />
        </BarChart>
      </ResponsiveContainer>

      <style jsx>{`
        .chart-container {
          width: 100%;
          height: 400px;
        }
      `}</style>
    </div>
  );
}



// WEBPACK FOOTER //
// components/stats/PerMonthStats.js